export default "__VITE_ASSET__8a7e3569__"